import { PageTitle, ResponsiveImage } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { marginBottom, mq } from '@sleepstation/style-api-helpers'
import { classStartsWithDirectChild } from '@sleepstation/style-mixins'
import { rem } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const IMAGE_ASPECT_RATIO = 698 / 369

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  align: LAYOUT_ALIGN.STRETCH,
  spacing: [LAYOUT_SPACING.LARGE, LAYOUT_SPACING.X_LARGE],
})`
  ${marginBottom([0.5])}
`

const ImageWrapper = styled.div`
  flex-grow: 1;
  ${classStartsWithDirectChild(`ResponsiveImage__Layout`)} {
    margin: 0 auto;
    ${mq(`mediumUp`)} {
      max-width: ${rem(525)};
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FullWidthCenteredImageHeader = ({ title, image }) => (
  <Layout>
    <ImageWrapper>
      <ResponsiveImage
        aspectRatio={IMAGE_ASPECT_RATIO}
        src={image.url}
        alt={image.alt}
      />
    </ImageWrapper>
    <PageTitle as={`h1`}>{title}</PageTitle>
  </Layout>
)

FullWidthCenteredImageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
}

export default FullWidthCenteredImageHeader
